document.addEventListener('DOMContentLoaded', () => {
    const unidade = document.querySelector('select[name="unidade"]');
    const ciclo = document.querySelector('select[name="ciclo"]');

    const opcoes = {
        "Unidade I": [
            "Infantil",
            "Fundamental 1",
            "Fundamental 2",
            "Ensino Médio",
            "Ensino Médio Técnico"
        ],
        "Unidade II": [
            "Berçário e Maternal",
            "Infantil",
            "Fundamental 1",
            "Fundamental 2",
            "Ensino Integral"
        ]
    };

    unidade.addEventListener('change', () => {
        ciclo.innerHTML = '';
        if (opcoes[unidade.value]) {
            ciclo.disabled = false;
            ciclo.append(new Option('Selecione o ciclo', ''));
            opcoes[unidade.value].forEach(op => ciclo.append(new Option(op, op)));
        } else {
            ciclo.disabled = true;
            ciclo.append(new Option('Selecione a unidade primeiro', ''));
        }
    });
});

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.cv-input').forEach(input => {
        const wrapper = input.closest('.file-upload');
        const filenameDisplay = wrapper.querySelector('.file-upload__filename');

        input.addEventListener('change', () => {
            filenameDisplay.textContent = input.files[0]?.name || 'Nenhum arquivo selecionado';
        });
    });
});